export interface Employee {
  id: string;
  name: string;
  position: string;
  employeeNumber: string;
  startDate: string;
}

export type RatingLevel = 'nicht-erfuellt' | 'teilweise-erfuellt' | 'erfuellt' | 'voll-erfuellt';

export interface CommentEntry {
  text: string;
  date: string;
  userId: string;
  userName: string;
}

export interface CriteriaRating {
  rating: RatingLevel | null;
  comments: CommentEntry[];
  points: number;
}

export interface EmployeeEvaluation {
  id: string;
  employeeId: string;
  month: string;
  date: string;
  criteria: {
    punctuality: CriteriaRating;
    dailyReport: CriteriaRating;
    measurements: CriteriaRating;
    noComplaints: CriteriaRating;
    overtime: CriteriaRating;
    projectDocumentation: CriteriaRating;
    costEstimate: CriteriaRating;
    communication: CriteriaRating;
    singleSickDays: CriteriaRating;
    totalSickDays: CriteriaRating;
    specialTasks: CriteriaRating;
    materialHandling: CriteriaRating;
    vehicleCare: CriteriaRating;
    projectCompletion: CriteriaRating;
  };
  totalScore: number;
  maxScore: number;
  performanceLevel: string;
  createdBy?: string; // User ID
  createdByName?: string; // User Name
}

export const criteriaList = [
  { key: 'punctuality', label: 'Pünktlichkeit beim Arbeitsbeginn' },
  { key: 'dailyReport', label: 'Tägliches Erstellen eines Bautagebuchs' },
  { key: 'measurements', label: 'Abschluss von Messarbeiten / Hochladen der Messungen' },
  { key: 'noComplaints', label: 'Keine Reklamationen seitens des Kunden' },
  { key: 'overtime', label: 'Bereitschaft für Überstunden und Samstagseinsätze' },
  { key: 'projectDocumentation', label: 'Dokumentation und Abschluss von Projekten' },
  { key: 'costEstimate', label: 'Einreichung eines brauchbaren Aufmaßes' },
  { key: 'communication', label: 'Kommunikation unter den Mitarbeitern' },
  { key: 'singleSickDays', label: 'Eintageskrankheitstage' },
  { key: 'totalSickDays', label: 'Krankheitstage gesamt' },
  { key: 'specialTasks', label: 'Übernahme von Sonderaufgaben' },
  { key: 'materialHandling', label: 'Umgang mit Material und Werkzeug' },
  { key: 'vehicleCare', label: 'Umgang mit KFZ (Reinigen innen und außen)' },
  { key: 'projectCompletion', label: 'Abschluss und Fertigstellung von Baustellen' },
] as const;

export const ratingOptions = [
  { value: 'nicht-erfuellt', label: 'Keine Erfüllung' },
  { value: 'teilweise-erfuellt', label: 'Teilweise erfüllt' },
  { value: 'erfuellt', label: 'Überwiegend erfüllt' },
  { value: 'voll-erfuellt', label: 'Voll erfüllt' },
] as const;
